import React from 'react'
import CoinMarket from '../Home/CoinMarket'
import WalletCards from './WalletCards'

import WalletButton from '../Wallet/WalletButton';
import WithdrawalButton from '../Withdrawal/WithdrawalButton';
import EarningAnalysis from '../Earning/EarningAnalysis';
import BalanceCard from '../Cards/BalanceCard';
import { CardActions, Card, CardContent, Grid, Typography, Box, Chip } from '@mui/material';
import Transactions from '../Transactions/Transactions';
import AssetButtons from './AssetsButtons';
import { useSelector } from 'react-redux';
import { useJointAccountBalance } from '../../hooks/useJointAccountBalance';
import { 
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Savings as SavingsIcon,
  TrendingUp as TrendingUpIcon,
  Star as StarIcon,
  AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';

const NewWallet = () => {
  const formatPrice = (amount) => new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: 'USD', 
    currencySign: 'standard' 
  }).format(amount);

  // Get balance data from Redux store
  const fundingBal = useSelector((state) => state.wallet.fundingBalance);
  const subBal = useSelector((state) => state.wallet.subscriptionBalance);
  const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
  const refBal = useSelector((state) => state.wallet.referralBalance);

  // Get joint account balance
  const { data: jointAccountData, isLoading: jointAccountLoading } = useJointAccountBalance();
  const jointAccountBalance = jointAccountData?.totalBalance || 0;
  const jointAccountCount = jointAccountData?.accountCount || 0;

  return (
    <div style={{marginTop: '85px'}}>
      {/* Original Balance Card */}
      <BalanceCard/>  
      <AssetButtons/>
      {/* Additional Balance Cards - Same as Dashboard */}
      <Box sx={{ mb: 3, px: 2 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={6} md={3}>
            <Card sx={{ 
              background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
              border: '1px solid #2B3139',
              borderRadius: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%',
              '&:hover': {
                borderColor: '#F7931A',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 20px rgba(247, 147, 26, 0.2)'
              }
            }}>
              <CardContent sx={{ 
                padding: { xs: '12px !important', md: '16px !important' },
                '&:last-child': { paddingBottom: { xs: '12px !important', md: '16px !important' } }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  mb: { xs: 1, md: 1.5 }
                }}>
                  <AccountBalanceWalletIcon sx={{ 
                    fontSize: { xs: 24, md: 28 }, 
                    color: '#F7931A' 
                  }} />
                  <Chip 
                    label="Overall Assets" 
                    size="small" 
                    sx={{ 
                      background: 'rgba(247, 147, 26, 0.1)', 
                      color: '#F7931A',
                      fontSize: { xs: '8px', md: '10px' },
                      fontWeight: 600,
                      height: { xs: '20px', md: '24px' }
                    }} 
                  />
                </Box>
                <Typography variant="h6" sx={{ 
                  color: '#FFFFFF', 
                  fontWeight: 700, 
                  fontSize: { xs: '14px', md: '16px' }, 
                  mb: 0.5,
                  lineHeight: 1.2
                }}>
                  {formatPrice(fundingBal)}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B7BDC6', 
                  fontSize: { xs: '10px', md: '11px' },
                  lineHeight: 1.2
                }}>
                  Total Portfolio Value
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={6} md={3}>
            <Card sx={{ 
              background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
              border: '1px solid #2B3139',
              borderRadius: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%',
              '&:hover': {
                borderColor: '#02C076',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 20px rgba(2, 192, 118, 0.2)'
              }
            }}>
              <CardContent sx={{ 
                padding: { xs: '12px !important', md: '16px !important' },
                '&:last-child': { paddingBottom: { xs: '12px !important', md: '16px !important' } }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  mb: { xs: 1, md: 1.5 }
                }}>
                  <SavingsIcon sx={{ 
                    fontSize: { xs: 24, md: 28 }, 
                    color: '#02C076' 
                  }} />
                  <Chip 
                    label="Invested Capital" 
                    size="small" 
                    sx={{ 
                      background: 'rgba(2, 192, 118, 0.1)', 
                      color: '#02C076',
                      fontSize: { xs: '8px', md: '10px' },
                      fontWeight: 600,
                      height: { xs: '20px', md: '24px' }
                    }} 
                  />
                </Box>
                <Typography variant="h6" sx={{ 
                  color: '#FFFFFF', 
                  fontWeight: 700, 
                  fontSize: { xs: '14px', md: '16px' }, 
                  mb: 0.5,
                  lineHeight: 1.2
                }}>
                  {formatPrice(subBal)}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B7BDC6', 
                  fontSize: { xs: '10px', md: '11px' },
                  lineHeight: 1.2
                }}>
                  Active Investments
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={6} md={3}>
            <Card sx={{ 
              background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
              border: '1px solid #2B3139',
              borderRadius: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%',
              '&:hover': {
                borderColor: '#FFD700',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 20px rgba(255, 215, 0, 0.2)'
              }
            }}>
              <CardContent sx={{ 
                padding: { xs: '12px !important', md: '16px !important' },
                '&:last-child': { paddingBottom: { xs: '12px !important', md: '16px !important' } }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  mb: { xs: 1, md: 1.5 }
                }}>
                  <TrendingUpIcon sx={{ 
                    fontSize: { xs: 24, md: 28 }, 
                    color: '#FFD700' 
                  }} />
                  <Chip 
                    label="Accumulated Profit" 
                    size="small" 
                    sx={{ 
                      background: 'rgba(255, 215, 0, 0.1)', 
                      color: '#FFD700',
                      fontSize: { xs: '8px', md: '10px' },
                      fontWeight: 600,
                      height: { xs: '20px', md: '24px' }
                    }} 
                  />
                </Box>
                <Typography variant="h6" sx={{ 
                  color: '#FFFFFF', 
                  fontWeight: 700, 
                  fontSize: { xs: '14px', md: '16px' }, 
                  mb: 0.5,
                  lineHeight: 1.2
                }}>
                  {formatPrice(mainBal)}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B7BDC6', 
                  fontSize: { xs: '10px', md: '11px' },
                  lineHeight: 1.2
                }}>
                  Total Earnings
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={6} md={3}>
            <Card sx={{ 
              background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
              border: '1px solid #2B3139',
              borderRadius: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%',
              '&:hover': {
                borderColor: '#9C27B0',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 20px rgba(156, 39, 176, 0.2)'
              }
            }}>
              <CardContent sx={{ 
                padding: { xs: '12px !important', md: '16px !important' },
                '&:last-child': { paddingBottom: { xs: '12px !important', md: '16px !important' } }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  mb: { xs: 1, md: 1.5 }
                }}>
                  <StarIcon sx={{ 
                    fontSize: { xs: 24, md: 28 }, 
                    color: '#9C27B0' 
                  }} />
                  <Chip 
                    label="Referral Wallet" 
                    size="small" 
                    sx={{ 
                      background: 'rgba(156, 39, 176, 0.1)', 
                      color: '#9C27B0',
                      fontSize: { xs: '8px', md: '10px' },
                      fontWeight: 600,
                      height: { xs: '20px', md: '24px' }
                    }} 
                  />
                </Box>
                <Typography variant="h6" sx={{ 
                  color: '#FFFFFF', 
                  fontWeight: 700, 
                  fontSize: { xs: '14px', md: '16px' }, 
                  mb: 0.5,
                  lineHeight: 1.2
                }}>
                  {formatPrice(refBal)}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B7BDC6', 
                  fontSize: { xs: '10px', md: '11px' },
                  lineHeight: 1.2
                }}>
                  Referral Earnings
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          {/* Joint Account Balance Card */}
          <Grid item xs={6} md={3}>
            <Card sx={{ 
              background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
              border: '1px solid #2B3139',
              borderRadius: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%',
              '&:hover': {
                borderColor: '#3B82F6',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 20px rgba(59, 130, 246, 0.2)'
              }
            }}>
              <CardContent sx={{ 
                padding: { xs: '12px !important', md: '16px !important' },
                '&:last-child': { paddingBottom: { xs: '12px !important', md: '16px !important' } }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  mb: { xs: 1, md: 1.5 }
                }}>
                  <AccountBalanceIcon sx={{ 
                    fontSize: { xs: 24, md: 28 }, 
                    color: '#3B82F6' 
                  }} />
                  <Chip 
                    label={`${jointAccountCount} Account${jointAccountCount !== 1 ? 's' : ''}`}
                    size="small" 
                    sx={{ 
                      background: 'rgba(59, 130, 246, 0.1)', 
                      color: '#3B82F6',
                      fontSize: { xs: '8px', md: '10px' },
                      fontWeight: 600,
                      height: { xs: '20px', md: '24px' }
                    }} 
                  />
                </Box>
                <Typography variant="h6" sx={{ 
                  color: '#FFFFFF', 
                  fontWeight: 700, 
                  fontSize: { xs: '14px', md: '16px' }, 
                  mb: 0.5,
                  lineHeight: 1.2
                }}>
                  {jointAccountLoading ? '...' : formatPrice(jointAccountBalance)}
                </Typography>
                <Typography variant="caption" sx={{ 
                  color: '#B7BDC6', 
                  fontSize: { xs: '10px', md: '11px' },
                  lineHeight: 1.2
                }}>
                  Joint Account Balance
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      
        
      <Transactions/>
    </div>
  )
}

export default NewWallet
